/**
 * Initialise Vanta waves on the homepage service grid.
 * Requires three.js r134 + vanta.waves (enqueued via functions/enqueue.php).
 */
export function initServiceGridWaves() {
    const el = document.querySelector('.service-grid--waves .service-grid__bg');

    if (!el) {
        return null;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return null;
    }

    if (typeof window.VANTA === 'undefined' || typeof window.VANTA.WAVES !== 'function') {
        return null;
    }

    return window.VANTA.WAVES({
        el,
        mouseControls: true,
        touchControls: true,
        gyroControls: false,
        minHeight: 200.0,
        minWidth: 200.0,
        scale: 1.0,
        scaleMobile: 1.0,
        color: 0x707070,
        shininess: 0.0,
        waveHeight: 4.5,
        waveSpeed: 0.55,
        zoom: 0.65,
    });
}
